import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthGuard } from '@/components/auth';
import LoginPage from '@/pages/LoginPage';
import RegisterPage from '@/pages/RegisterPage';
import ChatPage from '@/pages/ChatPage';
import TestPage from '@/pages/TestPage';

const App: React.FC = () => {
  return (
    <div className="App">
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/test" element={<TestPage />} />
        
        {/* Protected Routes */}
        <Route 
          path="/chat" 
          element={
            <AuthGuard>
              <ChatPage />
            </AuthGuard>
          } 
        />
        
        {/* Default redirect */}
        <Route path="/" element={<Navigate to="/chat" replace />} />
        
        {/* Catch all - redirect to chat */}
        <Route path="*" element={<Navigate to="/chat" replace />} />
      </Routes>
    </div>
  );
};

export default App;